module.exports = __webpack_public_path__ + "static/assets/50202add38be280f7fd82a416a2ec06a.png";